<template>
  <div>
    <el-card style="height:460px;">
      <div slot="header">
        <span>任务逾期情况</span>
        <el-select
          @change="onPeriodChange"
          v-model="dtPeriod"
          placeholder="请选择"
          size="mini"
          class="top-selector"
        >
          <el-option
            v-for="period in dtPeriodList"
            :key="period.key"
            :label="period.text"
            :value="period.key"
          ></el-option>
        </el-select>
        <el-select
          @change="onTypeChange"
          v-model="dtType"
          placeholder="请选择"
          size="mini"
          class="top-selector"
        >
          <el-option
            v-for="type in dtTypeList"
            :key="type.key"
            :label="type.text"
            :value="type.key"
          ></el-option>
        </el-select>
      </div>
      <div id="taskStatOverdueLine" style="width:100%;height:365px;"></div>
    </el-card>
  </div>
</template>

<script>
import { GetTaskDelayStatsByDate } from "@/api/modules/basicData/task.js";
let echarts = require("echarts");
export default {
  name: "TaskStatOverdueLine",
  data: function() {
    return {
      dtType: "0",
      dtPeriod: "0",
      dtTypeList: [
        { key: "0", text: "创建时间" },
        { key: "1", text: "接收时间" },
        { key: "2", text: "完成时间" }
      ],
      dtPeriodList: [
        { key: "0", text: "最近7天" },
        { key: "1", text: "最近15天" },
        { key: "2", text: "最近30天" },
        { key: "3", text: "最近6个月" },
        { key: "4", text: "最近1年" }
      ],
      request:{}
    };
  },
  methods: {
    draw(
      titles_all,
      values_all,
      titles_plan,
      values_plan,
      titles_process,
      values_process
    ) {
      let dom = document.getElementById("taskStatOverdueLine");
      if(!dom){
        return;
      }
      let chart = echarts.init(dom);
      let option = {
        legend: {
          data: ["全部逾期", "进度逾期", "操作超期"]
        },
        xAxis: {
          type: "category",
          data: titles_all
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "全部逾期",
            type: "line",
            data: values_all
          },
          {
            name: "进度逾期",
            type: "line",
            data: values_plan
          },
          {
            name: "操作超期",
            type: "line",
            data: values_process
          }
        ]
      };
      chart.setOption(option);
    },
    refresh(request) {
      this.request=request;
      GetTaskDelayStatsByDate({
        TimeType: this.dtType,
        TimeRange: this.dtPeriod,
        UserId: request.UserId,
        TaskIds: request.TaskIds || "",
        Paras: request.Paras || {},
        ServerCenterId: request.ServerCenterId || ""
      })
        .then(res => {
          let res_all = res.filter(task => task.Name == "全部逾期");
          let res_plan = res.filter(task => task.Name == "进度逾期");
          let res_process = res.filter(task => task.Name == "操作超期");
          let titles_all = res_all.map(task => task.Item.split("T")[0]);
          let values_all = res_all.map(task => task.Value);
          let titles_plan = res_plan.map(task => task.Item.split("T")[0]);
          let values_plan = res_plan.map(task => task.Value);
          let titles_process = res_process.map(task => task.Item.split("T")[0]);
          let values_process = res_process.map(task => task.Value);
          this.draw(
            titles_all,
            values_all,
            titles_plan,
            values_plan,
            titles_process,
            values_process
          );
        })
        .catch(error => {
          console.log(error);
          // this.$message.error("获取统计数据失败");
        });
    },
    onPeriodChange(period) {
      this.refresh(this.request);
    },
    onTypeChange(type) {
      this.refresh(this.request);
    }
  }
};
</script>

<style lang="less" scoped>
.top-selector {
  margin-top: -4px;
  margin-left: 12px;
  width: 100px;
  float: right;
}
</style>
